import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalDocumentsService {

  constructor(public apiService: ApiService) {}

  getAllGlobalDocuments(): Observable<any> {
    return this.apiService.get('globalDocuments/getAllGlobalDocuments');
  }

  cloneToCompany(payload: { global_doc_ids: number[]; company_id: number }): Observable<any> {
    return this.apiService.post('globalDocuments/cloneToCompany', payload);
  }

  addGlobalDocument(payload: { title: string; doc_type_id: number; editorContent: string }): Observable<any> {
    return this.apiService.post('globalDocuments/addGlobalDocument', payload);
  }

  getDocumentTypes(): Observable<any> {
    return this.apiService.get('globalDocuments/getDocumentTypes');
  }

  editGlobalDocument(id: number, payload: { title: string; doc_type_id: number; editorContent: string }): Observable<any> {
    return this.apiService.put('globalDocuments/editGlobalDocument', id, payload);
  }

  deleteGlobalDocument(id: number): Observable<any> {
    return this.apiService.delete('globalDocuments/deleteGlobalDocument', id);
  }
}
